import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-cargando',
  templateUrl: './modal-cargando.component.html',
  styleUrls: ['./modal-cargando.component.css']
})
export class ModalCargandoComponent implements OnInit {

  mensaje: string = '';
  
  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onClickDismiss(event: Event, res: string):void{
    this.modal.dismiss(res);
  };

}
